export enum modalState {
    show = "show",
    hide = "hide",
}
